import React, { useContext, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import InputDefault from '../../components/InputDefault';
import InputDate from '../../components/InputDate';
import RadioButtonForm from '../../components/RadioButtonForm';
import { SecondaryLargeButton, DefaultLargeButton } from '../../components/Buttons/styles';
import FormTemplate from '../../components/FormTemplate';
import Loader from '../../components/Loader';
import { Form, FormFooter, FormRow } from '../../components/FormTemplate/styles';
import { useHistory, useLocation } from 'react-router-dom';
import ModalActionCongratulations from '../../components/ModalActionCongratulations';
import { BsCheck } from 'react-icons/bs';
import SearchField from '../../components/SearchField';
import { getAllCities, getStates } from '../../services/states';
import { getCities } from '../../services/cities';
import { saveClientData } from '../../services/clients';
import {
  ClientsContainer,
  ClientsWrapper,
  ClientsHeader,
  ClientsHaderTitle,
} from '../ClientList/styles';
import {
  ClientsContent,
} from './styles';
import { H4 } from '../../components/Typography/styles';
import Copyright from '../../components/Copyright';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import { SessionContext } from '../../store';
import { getPermiteCambio } from '../../services/desk';
import InputDefaultOnlyText from '../../components/InputDefaultOnlyText';

const ClientModifyPage = () => {
  const session = useContext(SessionContext);
  const location = useLocation();
  const history = useHistory();
  const { control, register, errors, setValue, handleSubmit, watch } = useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [showState, setShowState] = useState(false);
  const [showCity, setShowCity] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [idCityExp, setIdCityExp] = useState('');
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [gender, setGender] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const fields = watch();
  const [showCities, setShowCities] = useState(false);
  const [allFilteredCities, setAllFilteredCities] = useState([]);
  const [cities2, setCities2] = useState([]);
  const [showNames, setShowNames] = useState(false);
  const [roles, setRoles] = useState(['rol_analista_gestion', 'rol_analista_gestion_comercial_i', 'rol_analista_gestion_comercial_ii', 'rol_analista_gestion_comercial_premium', 'rol_lider_comercial', 'rol_lider_comercial_oficina', 'rol_lider_comercial_agencia']);

  async function initializeStateComponent() {
    try {
      setValue('fechaNacimiento', location.client.fechaNacimiento);
      setValue('fechaExpedicionDocumento', location.client.fechaExpedicionDocumento);
      const changeNames = await getPermiteCambio(location.client.id)
      console.log("lo que devuelve: " + (roles.includes(session.rol) && changeNames.data))
      console.log("session.rol: " + session.rol)
      setShowNames((roles.includes(session.rol) && changeNames.data))
      setGender(location.client.genero);
      const states = await getStates();
      const response = await getAllCities();
      response.data.forEach(function (objeto) {
        var id = objeto.id.split('>')[1];
        objeto.nombre = objeto.nombre + ' (' + id + ')';
      });
      setCities2(response.data);
      setStates(states.data);
      if (location.client.idCiudadExpedicionIdentificacion) {
        const arr = location.client.idCiudadExpedicionIdentificacion.split('>');
        const idState = arr[0] + '>' + arr[1];
        const cities = await getCities(idState);
        setSelectedState(states.data.find(state => state.id === idState));
        setSelectedCity(cities.data.find(city => city.id === location.client.idCiudadExpedicionIdentificacion))
        setCities(cities.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error)
      console.log(error.response)
    }
  }

  async function setCompleteStep(formData) {
    try {
      setIsLoading(true);
      var numberOfMlSeconds = new Date(formData.fechaExpedicionDocumento);
      numberOfMlSeconds = numberOfMlSeconds.getTime();
      var addMlSeconds = 900 * 60000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);

      var numberOfMlSecondsDos = new Date(formData.fechaNacimiento);
      numberOfMlSecondsDos = numberOfMlSecondsDos.getTime();
      var addMlSecondsDos = 900 * 60000;
      var newDateObjDos = new Date(numberOfMlSecondsDos + addMlSecondsDos);

      const data = {
        fechaExpedicionDocumento: newDateObj ? newDateObj : location.client.fechaExpedicionDocumento,
        idCiudadExpedicionIdentificacion: idCityExp,
        lugarExpedicionIdentificacion: formData.city ? formData.city : location.client.lugarNacimiento,
        fechaNacimiento: location.client.fechaNacimiento,
        lugarNacimiento: formData.lugarNacimiento ? formData.lugarNacimiento : location.client.lugarNacimiento,
        genero: gender ? gender : location.client.genero,
        id: location.client.id,
        primerNombre: formData.primerNombre,
        segundoApellido: formData.segundoApellido,
        primerApellido: formData.primerApellido,
        segundoNombre: formData.segundoNombre
      }
      await saveClientData(data);
      setShowSuccessModal(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function setSelectedCity(city) {
    setValue('city', city.nombre);
    setIdCityExp(city.id);
    setShowCity(false);
  }

  async function selectCity(city) {
    setValue('lugarNacimiento', city.nombre);
    setShowCities(false);
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);
      setValue('state', state.nombre);

      if (fields.city) {
        setValue('city', '');
        setShowCity(false);
      }

      setIsLoading(false);
      setShowState(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function searchInCities(e) {
    setShowCity(true);
    setShowState(false);
    let filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function searchInAllCities(e) {
    setShowCities(true);
    let allFiltered = cities2.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setAllFilteredCities(allFiltered);
  }

  function searchInState(e) {
    setShowState(true);
    setShowCity(false);
    let filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function setGeneroRadioChecked(radio) {
    setGender(radio.value);
  }

  function goToNextStep() {
    setShowSuccessModal(false);
    history.push({
      pathname: '/admin/client-list',
      idCredit: location.idCredit
    })
  }

  useEffect(() => {
    if (!location.client) {
      return history.push({
        pathname: '/admin/client-list'
      });
    }
    initializeStateComponent();
    return () => {
      setCities([]);
      setStates([]);
      setFilteredCities([]);
      setFilteredStates([]);
    };
  }, [])

  useEffect(() => {
    if(showNames){
      setValue('primerNombre', location.client.primerNombre);
      setValue('segundoNombre', location.client.segundoNombre);
      setValue('primerApellido', location.client.primerApellido);
      setValue('segundoApellido', location.client.segundoApellido);
    }
  }, [showNames])

  return (
    <ClientsContainer id="clients-page">
      <ClientsWrapper>
        <ClientsHeader>
          <ClientsHaderTitle>Novedades</ClientsHaderTitle>
          <H4 color={colors.textPrimary}>Modificar Datos</H4>
        </ClientsHeader>
        <ClientsContent>
          <FormSteps lastStep={0} steps={[
            { number: 1, label: 'Modificar Datos Cliente' }
          ]} />
          <FormTemplate
            idForm="basic-data-step-page"
            activeStep="1/1"
            stepLabel="Modificar Datos Cliente">
            <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
              <FormRow>
                <SearchField
                  label="Ciudad de Nacimiento"
                  name="lugarNacimiento"
                  id="lugarNacimiento"
                  show={showCities}
                  list={allFilteredCities}
                  defaultValue={location.client.lugarNacimiento}
                  selectField={selectCity}
                  searchInList={searchInAllCities}
                  register={register({
                    required: "Este dato es obligatorio",
                    pattern: {
                      value: /^[a-zA-Z()\u00E0-\u00FC ]*$/,
                      message: "Error en la ciudad, ingresa una válida",
                    }
                  })}
                  placeholder="Buscar..."
                  error={errors.lugarNacimiento} />
                <InputDate
                  aria-required
                  type="date"
                  error={errors.fechaNacimiento}
                  label="Fecha de expedición"
                  name="fechaExpedicionDocumento"
                  id="fechaExpedicionDocumento"
                  register={register({ required: "Este dato es obligatorio" })}
                  onBlur={() => { }} />
              </FormRow>
              {showNames &&
                <div style={{display: 'none'}}>
                  <FormRow col="2">
                    <Controller
                      as={InputDefaultOnlyText}
                      control={control}
                      label="Primer Nombre"
                      name="primerNombre"
                      register={register({ required: "Este dato es obligatorio" })}
                      id="primerNombre"
                      error={errors.primerNombre}
                      value={location.client.primerNombre} />
                    <Controller
                      as={InputDefaultOnlyText}
                      control={control}
                      label="Segundo Nombre"
                      name="segundoNombre"
                      register={register}
                      id="segundoNombre"
                      value={location.client.segundoNombre} />
                  </FormRow>
                  <FormRow col="2">
                    <Controller
                      as={InputDefaultOnlyText}
                      control={control}
                      label="Primer Apellido"
                      name="primerApellido"
                      register={register({ required: "Este dato es obligatorio" })}
                      id="primerApellido"
                      error={errors.primerApellido}
                      value={location.client.primerApellido}
                      readOnly />
                    <Controller
                      as={InputDefaultOnlyText}
                      control={control}
                      label="Segundo Apellido"
                      name="segundoApellido"
                      register={register}
                      id="segundoApellido"
                      value={location.client.segundoApellido} />
                  </FormRow>
                </div>
              }
              {/*<FormRow col="2">
                <InputDate
                  aria-required
                  type="date"
                  error={errors.fechaNacimiento}
                  label="Fecha de nacimiento"
                  name="fechaNacimiento"
                  id="fechaNacimiento"
                  register={register({ required: "Este dato es obligatorio" })}
                  onBlur={() => { }} />
                  
                <Controller
                  type="text"
                  as={InputDefault}
                  control={control}
                  label="Lugar de nacimiento"
                  error={errors.lugarNacimiento}
                  name="lugarNacimiento"
                  id="lugarNacimiento"
                  register={register({ required: "Este dato es obligatorio" })}
                  defaultValue={location.client.lugarNacimiento} />
              </FormRow>
              <FormRow col="2">
                <SearchField
                  label="Departamento de Expedición"
                  name="state"
                  id="state"
                  show={showState}
                  list={filteredStates}
                  selectField={setSelectedState}
                  searchInList={searchInState}
                  register={register({ required: "Este dato es obligatorio" })}
                  placeholder="Buscar..."
                  error={errors.state} />
                <SearchField
                  label="Ciudad o Municipio de Expedición"
                  name="city"
                  id="city"
                  show={showCity}
                  list={filteredCities}
                  selectField={setSelectedCity}
                  searchInList={searchInCities}
                  register={register({ required: "Este dato es obligatorio" })}
                  placeholder="Buscar..."
                  error={errors.city}
                  disabled={!fields.state} />
              </FormRow>
              
              <FormRow col="2">
                
                <RadioButtonForm
                  label="Genero"
                  setIdentificationRadioChecked={setGeneroRadioChecked}
                  selected={gender}
                  name="genero"
                  id="genero"
                  radios={[
                    { label: 'M', value: 'M' },
                    { label: 'F', value: 'F' }
                  ]} />
              </FormRow>*/}
              <FormFooter justify="space-between">
                <DefaultLargeButton type="button" onClick={() => history.push({ pathname: '/admin/client-list' })} id="back-step">Volver</DefaultLargeButton>
                <SecondaryLargeButton type="submit" id="submit">Guardar</SecondaryLargeButton>
              </FormFooter>
              {isLoading && <Loader />}
            </Form>
            <ModalActionCongratulations
              open={showSuccessModal}
              setShowModal={setShowSuccessModal}
              actionFunctionUpButton={() => goToNextStep()}
              title="Información Guardada"
              actionLabelFunctionUpButton="Volver"
              description="La información del cliente ha sido guardada exitosamente."
              backgroundIcon={colors.textHyperlink}
              bodyIcon={<BsCheck size={32} color={colors.white} />} />
          </FormTemplate>
        </ClientsContent>
      </ClientsWrapper>
      <Copyright />
    </ClientsContainer>
  )
}

export default ClientModifyPage
